import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {Workbook as wb} from "exceljs";
import {ModificacionMarcionesService} from "../../../horas-extras/services/modificacion-marcaciones.service";
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import {
  ReportePerformService
} from "../../services/reporte-perform-services/parametro-conciliacion-bancaria.service";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";

@Component({
  selector: 'app-reporte-perform',
  templateUrl: './reporte-perform.component.html',
  styleUrls: ['./reporte-perform.component.css']
})
export class ReportePerformComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: string = 'ListaCobros';
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioExtractos: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  gridApiPedidos: any;
  gridColumnApiPedidos: any;
  rowDataPedidos: any[];
  rowSelectionPedidos: any;
  columnDefsPedidos: any[];
  frameworkComponentsPedidos: any;

  gridApiExtractos: any;
  gridColumnApiExtractos: any;
  rowDataExtractos: any[];
  rowSelectionExtractos: any;
  columnDefsExtractos: any[];
  frameworkComponentsExtractos: any;


  rowSelected: any;
  rowSelectedExtractos: any;


  obligatorylocality: boolean = false;
  today: any;
  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  mostrarTabla = false;
  recursosHumanos = false;
  @ViewChild('fileInput') fileInput: ElementRef;

  cmbEan14: any[] = [];
  cmbLote: any[] = [];
  cmbEstado: any[] = [{clave:"1",valor:"CORRECTO"},
                      {clave:"2",valor:"RECH. BAJO PESO"},
                      {clave:"3",valor:"RECH. SOBRE PESO"},
                      {clave:"4",valor:"RECH. CAJA ABIERTA"},
                      {clave:"5",valor:"RECH. COD NO REGISTRADO"},
                      {clave:"6",valor:"RECH. COD NO DEFINIDO"}]

  break = false;


  constructor(
    private fb: FormBuilder,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _util: UtilsService,
    private _paramReporte: ReportePerformService,
    private _datosMaestros: DatosMaestrosService,
  ) {
    this.diccionarioModulo = moduloPerform;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloPerform.button.buttonsNombre;
    this.DAT_TITULOS = moduloPerform.titulos.autorizacionCobros;
    this.DAT_BTNCSS = moduloPerform.button.buttonsCss;
    this.DAT_MSG = moduloPerform.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    //this.llenarCombos();
    //this.calculateCombos();
    this.formulario = this.fb.group({
      fechaIni: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      ean14: '',
      lote: '',
      estado: '',
    });
    this.formularioExtractos = this.fb.group({
      idBanco: '',
    });
    this.girdComponent();
  }

  validateForm() {
    return !(this.gridApiExtractos && this.gridApiExtractos.getSelectedRows() && this.gridApiExtractos.getSelectedRows().length > 0);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  llenarCombos() {
    this.cargarBanco();
    this.cargarTipoPago();
    this.cargarAgencia();
  }

  onGridReadyPedidos(params) {
    this.gridApiPedidos = params.api;
    this.gridColumnApiPedidos = params.columnApi;
  }

  onGridReadyExtractos(params) {
    this.gridApiExtractos = params.api;
    this.gridColumnApiExtractos = params.columnApi;
  }

  cargarPerformReporte(){

  }

  /*cargarCobros() {
    this.loading = true;
    this.mostrarTabla = true;
    const payload = this.formulario.value;
    this._paramConciBanca.getCobrosPendientes(payload).subscribe((res: any) => {
      if (res && res.registros && res.registros.length > 0) {
        this.rowData = res.registros.flatMap(obj =>
          obj.pagosDetalle.map(pagoDetalle =>
            ({pagoDetalle, cobro: obj})
          )
        );
        console.log(this.rowData);
      } else {
        this.rowData = [];
      }
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }*/


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      /*{
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.procesarExtractos.bind(this),
          label: this.DAT_BTNS.procesar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.verPedidos.bind(this),
          label: this.DAT_BTNS.verPedidos,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.rechazarCobro.bind(this),
          label: this.DAT_BTNS.rechazar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },*/
      {
        headerName: 'CANT.',
        field: 'cantidad',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ID MATERIAL',
        field: 'idMaterial',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descMaterial',
        sortable: true,
        filter: true,
        width: 350
      },
      {
        headerName: 'EAN14',
        field: 'ean14',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'LOTE',
        field: 'lote',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ESTADO',
        field: 'estado',
        sortable: true,
        filter: true,
        width: 200,
        valueGetter: function (params) {
          // debugger
          let data = params.data;
          switch(data.estado){
            case 1:
              return "CORRECTO";
            case 2:
              return "RECH. BAJO PESO";
            case 3:
              return "RECH. SOBRE PESO";
            case 4:
              return "RECH. CAJA ABIERTA";
            case 5:
              return "RECH. COD NO REGISTRADO";
            case 6:
              return "RECH. COD NO DEFINIDO"; 
            default:
              return "UNDEFINDED";           
          }

      }
    }
    ];
    this.rowSelection = 'single';
  }


  girdComponentPedidos() {
    this.frameworkComponentsPedidos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsPedidos = [
      {
        headerName: 'CLIENTE',
        field: 'rowData.cobro.cliente.nombreCliente1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'VENDEDOR',
        field: 'rowData.cobro.vendedor.nombreVendedor1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'FORMA DE PAGO',
        field: 'rowData.pagoDetalle.tipoPago.descripcion',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'AGENCIA',
        field: 'rowData.cobro.agencia.descripcion',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'FECHA PEDIDO',
        field: 'pedFechaCreacion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'MONTO',
        field: 'pedValorPedido',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelectionPedidos = 'single';
  }

  obtainDate(){
    this.formulario.get('lote').setValue("");
    this.formulario.get('ean14').setValue("");
    this.cmbLote = [];

    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindCodigoEan(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('lote').value,
                                          this.formulario.get('estado').value,
                                        "").subscribe((resp) => {
        this.cmbEan14 = resp.sort((a, b) => b.clave.localeCompare(a.clave));
      }, (error) => {
        this.cmbEan14 = [];
        console.log(error);
      });
    }
  }

  obtainLote(){
    this.formulario.get('lote').setValue("");
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindCodigoLote(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('estado').value,
                                        "").subscribe((resp) => {
        this.cmbLote = resp.sort();
      }, (error) => {
        this.cmbLote = [];
        console.log(error);
      });
    }
  }

  generarReport(){
    this.loading = true;
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindReport(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('lote').value,
                                          this.formulario.get('estado').value).subscribe((resp) => {
        this.rowData = resp;
        this.mostrarTabla = true;
        this.loading = false;
      }, (error) => {
        this.rowData = [];
        this.loading = false;
        console.log(error);
      });
    }
  }


  girdComponentExtractos() {
    this.frameworkComponentsExtractos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsExtractos = [
      {
        headerName: '',
        sortable: true,
        filter: true,
        width: 300,
        checkboxSelection: true,
      },
      {
        headerName: 'BANCO ID',
        field: 'idBanco',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'CUENTA',
        field: 'cuentaBancaria',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'FECHA EXTRACTO',
        field: 'fechaExtracto',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NUMERO EXTRACTO',
        field: 'numeroExtracto',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NUMERO REFERENCIA',
        field: 'numeroReferencia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'MONTO',
        field: 'monto',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelectionExtractos = 'multiple';
  }


  rechazarCobro({rowData}) {
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.rechazar,
        text: ``,
        action: this.DAT_BTNS.rechazar,
        funcion: this._paramReporte.rechazarCobro(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  procesarExtractos({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardProcesarExtractos;
    this.mostrarGridLista = 'ListaExtractos';
    this.textBoton = this.DAT_BTNS.procesar;
    console.log(rowData);

    this.formularioExtractos.get('idBanco').setValue(rowData && rowData.pagoDetalle && rowData.pagoDetalle.pagIdBancoContable ? rowData.pagoDetalle.pagIdBancoContable : '');
    this.getExtractos(rowData);
    //this.rowDataPedidos = rowData.pedidos;
    this.girdComponentExtractos();
  }

  cargarBanco() {
    // this._paramConciBanca.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
    this._datosMaestros.getAllBancoActivos().subscribe((resp) => {
      //this.cmbBanco = this.concatenarBancoId(resp);
    }, (error) => {
      //this.cmbBanco = [];
      console.log(error);
    });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }


  cargarTipoPago() {
    this._datosMaestros.getAllTipoPago().subscribe((resp) => {
      //this.cmbTipoPago = resp;
    }, (error) => {
      //this.cmbTipoPago = [];
      console.log(error);
    });
  }

  cargarAgencia() {
    this._datosMaestros.getAllOficinasVentas().subscribe((resp) => {
      //this.cmbAgencia = resp;
    }, (error) => {
      //this.cmbAgencia = [];
      console.log(error);
    });
  }

  procesarExtractosClick() {
    this.loading = true;
    //this.rowSelectedExtractos = rowData;

    this.rowSelectedExtractos = this.gridApiExtractos.getSelectedRows();

    let conciliacionDatos = this.rowSelectedExtractos.map(data =>
      ({
        idEmpresa: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagEmpresa ? this.rowSelected.pagoDetalle.pagEmpresa : '',
        idBanco: this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
        claveBanco: data && data.claveBanco ? data.claveBanco : '',
        //cuentaBancaria: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagCtaBancaria ? this.rowSelected.pagoDetalle.pagCtaBancaria : '',
        cuentaBancaria: data && data.cuentaBancaria ? data.cuentaBancaria : '',
        numeroExtracto: data && data.numeroExtracto ? data.numeroExtracto : '',
        numeroReferencia: data && data.numeroReferencia ? data.numeroReferencia : '',
        idConciBancaDeta: data && data.idConciBancaDeta ? data.idConciBancaDeta : '',
      })
    );
    let payload = {
      cobroId: this.rowSelected && this.rowSelected.cobro && this.rowSelected.cobro.cobroId ? this.rowSelected.cobro.cobroId : '',
      pagConsecutivo: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagConsecutivo ? this.rowSelected.pagoDetalle.pagConsecutivo : 1,
      conciliacionDatos: conciliacionDatos
    };
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: ``,
        action: this.DAT_BTNS.procesar,
        funcion: this._paramReporte.procesarCobro(payload),
      }
    ).then((res: any) => {
        this.loading = false;
        //this.cargarCobros();
        this.regresar();
      }, () => {
        this.loading = false;
      }
    );
  }

  getExtractos(data) {
    let payload = {
      'fechaExtracto': this.formulario && this.formulario.get('date') && this.formulario.get('date').value ? this.formulario.get('date').value : '',
      'idBanco': this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
      'idEmpresa': data && data.pagoDetalle && data.pagoDetalle.pagEmpresa ? data.pagoDetalle.pagEmpresa : '',
    };
    this.rowSelected = data;
    this.loading = true;
    this._paramReporte.getAllExtractoBancario(payload).subscribe((res: any) => {
      this.rowDataExtractos = res.map(data => (
        {
          ...data,
        }
      ));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowDataExtractos = [];
    });
  }

  verPedidos({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardPedidos;
    this.mostrarGridLista = 'ListaPedidos';
    this.rowSelected = rowData;
    this.rowDataPedidos = rowData.cobro.pedidos.map(data => (
      {
        ...data,
        rowData: this.rowSelected
      }
    ));
    this.girdComponentPedidos();
  }


  regresar() {
    this.formularioExtractos.reset();
    this.mostrarGridLista = 'ListaCobros';
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }


  acciones(event) {
    if (event === 'guardar') {
      this.procesarExtractosClick();
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = 'ListaCobros';
    }
  }

  exportCSV() {
    if(this.rowData === undefined || this.rowData.length === 0)
      return;
    const header: any[] = [["CANTIDAD","EAN14","ID_METRIAL","DESCRIPCION_MATERIAL","LOTE" ,"ESTADO"]];
    const listAux: any[] = this.rowData.map((item) => Object.assign({}, item));
    console.log(this.rowData);
    const body: any[] = listAux.map(item => {
      switch(item.estado){
        case 1:
          item.estado = "CORRECTO";
          break;
        case 2:
          item.estado ="RECH. BAJO PESO";
          break;
        case 3:
          item.estado ="RECH. SOBRE PESO";
          break;
        case 4:
          item.estado ="RECH. CAJA ABIERTA";
          break;
        case 5:
          item.estado ="RECH. COD NO REGISTRADO";
          break;
        case 6:
          item.estado ="RECH. COD NO DEFINIDO"; 
          break;
        default:
          item.estado ="UNDEFINDED";           
      }
      return {
        cantidad: item.cantidad,
        ean14: item.ean14,
        idMaterial: item.idMaterial,
        descMaterial: item.descMaterial,
        lote: item.lote,
        estado:item.estado,
      }
    });
    this._util.exportCSV(header, body, "Reporte_Perform.csv");
  }

}
